// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__6OCqr","log":"ModalInventoryLogs_log__39_cC","date":"ModalInventoryLogs_date__83r0r","userName":"ModalInventoryLogs_userName__3SiNO"};